import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";

// Section API tab Trf di Menu Pembukuan. Trf Mandiri tetap memakai section lama `trf_mandiri_bri`.
export const TRF_SECTIONS = [
  { section: "trf_bca", label: "Trf BCA" },
  { section: "trf_mandiri_bri", label: "Trf Mandiri" },
  { section: "trf_bri", label: "Trf BRI" },
];

export const getTrfSectionLabel = (section) =>
  TRF_SECTIONS.find((item) => item.section === section)?.label || section;

export const normalizeTrfText = (value) => String(value || "").toUpperCase().replace(/\s+/g, " ").trim();
const toDateKey = (value) => (value ? String(value).slice(0, 10) : "");

// Kunci pencocokan: reservation_id (paling akurat) dan teks transaksi + tanggal
// (keterangan Trf disalin dari teks Accounting V2, dipakai selama BE belum mengembalikan reservation_id).
const getMatchKeys = ({ reservationId, text, date }) => {
  const keys = [];
  if (reservationId) keys.push(`id:${reservationId}`);
  const normalizedText = normalizeTrfText(text);
  if (normalizedText) keys.push(`txt:${normalizedText}|${toDateKey(date)}`);
  return keys;
};

const getRows = (response) => {
  const data = response?.data?.data ?? response?.data ?? response;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.rows)) return data.rows;
  return [];
};

// Ambil data Trf yang sudah ada (per section) di rentang tanggal tertentu.
export const fetchTrfEntries = async ({ sections = TRF_SECTIONS.map((item) => item.section), start, end }) => {
  const responses = await Promise.all(sections.map((section) => getRequest(`/accounting/additional-transactions${buildQueryString({
    start_date: start,
    end_date: end,
    section,
    all: 1,
  })}`).then((response) => ({ section, rows: getRows(response) }))));

  return responses.flatMap(({ section, rows }) => rows.map((row) => ({
    id: row.id,
    section: row.section || section,
    reservationId: row.reservation_id || null,
    text: row.description || row.name || "",
    date: toDateKey(row.date || row.transaction_date || row.created_at),
    amount: Number(row.amount) || 0,
    raw: row,
  })));
};

export const buildTrfIndex = (entries) => {
  const index = new Map();
  entries.forEach((entry) => {
    getMatchKeys(entry).forEach((key) => {
      if (!index.has(key)) index.set(key, []);
      index.get(key).push(entry);
    });
  });
  return index;
};

// Semua data Trf yang sama dengan kandidat (tanpa duplikasi entri), opsional dikecualikan id tertentu.
export const findTrfMatches = (candidate, index, { excludeIds = [] } = {}) => {
  const found = new Map();
  getMatchKeys(candidate).forEach((key) => {
    (index.get(key) || []).forEach((entry) => {
      if (!excludeIds.includes(entry.id)) found.set(`${entry.section}-${entry.id}`, entry);
    });
  });
  return [...found.values()];
};

export const getDateBounds = (dates) => {
  const valid = dates.map(toDateKey).filter(Boolean).sort();
  return valid.length ? { start: valid[0], end: valid[valid.length - 1] } : null;
};
